import { useEffect,useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { setOfflineGY } from "../redux/chartoptions";
import IndividualComponentPopup from "./individualcomponentpopup";



function OfflineGy(){
   
    const [showModal,setShowModal] = useState(false);

    const myData = useSelector(state => state.offlineApi);

    let current_Gy = myData.offline_Gy[0];

        
        
        const dispatch = useDispatch();
        const checked = useSelector(state => state.chartOption.offline_Gy)

        const showPopup = () =>{
            setShowModal(true);
        }
    
        const hidePopup = () =>{
            setShowModal(false);
        }
        

    return(
        <>
            <div className="parameter" id="offline-gy" onClick={showPopup}>                    
                <div className="label2">
                    <input type="checkbox" id="offlinegy" checked={checked} onChange={(e) => {dispatch(setOfflineGY(e.target.checked))}} />
                    <label htmlFor="offlinegy" >Offline &shy;Gy</label>
                </div>
                    
                <div className="parameter_ul">
                    <ul>
                        <li type="none">Current Gy : {parseFloat(current_Gy).toFixed(2)} <br/> </li>
                    </ul>
                </div>
            </div>
            {showModal && <IndividualComponentPopup hider={hidePopup} bgcolor={"#ffd9c05a"} />}
        </>
    );
}

export default OfflineGy;